import { Icon, IconProps } from "./Icon";

export function IconStar(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="m12 1.77 2.21 7.14.22.71h8l-5.94 4.52-.55.42.2.67 2.25 7.24-5.81-4.42-.58-.47-.61.47-5.81 4.42 2.25-7.24.2-.67-.55-.42-5.94-4.52h8l.22-.71L12 1.77M12 0a.67.67 0 0 0-.65.5L8.83 8.62H.69a.73.73 0 0 0-.41 1.3l6.59 5-2.51 8.13A.71.71 0 0 0 5 24a.63.63 0 0 0 .4-.14l6.59-5 6.59 5A.63.63 0 0 0 19 24a.71.71 0 0 0 .65-.95l-2.51-8.11 6.59-5a.73.73 0 0 0-.41-1.3h-8.15L12.65.5A.67.67 0 0 0 12 0Z" />
    </Icon>
  );
}
